"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldSet = void 0;
var _react = require("react");
var _classVarianceAuthority = require("class-variance-authority");
var _helpers = require("../../common/helpers");
var _classes = require("../../common/classes");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["name", "label", "helperText", "error", "required", "disabled", "direction", "className", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var formClasses = (0, _classVarianceAuthority.cva)([]);
var controlClasses = (0, _classVarianceAuthority.cva)(['flex', 'my-3'], {
  variants: {
    direction: {
      row: ['flex-row', 'gap-x-10'],
      column: ['flex-col', 'gap-y-3']
    }
  }
});

// use fieldprops? // override error state for consistency
// this might just be renamed to fieldset
// onChange should say which value is selected

/**
 * Field Set - [API](https://reimagined-adventure-37999z9.pages.github.io/?path=/docs/inputs-fieldset) | [DSM](https://sharphealthcare.notion.site/Inputs-4a77e695a529479fa701e2f3dcdc47e7#c106fc2ccd7249febfb38d2cf82b5e8d)
 *
 * Use this with checkbox or radio controls.
 */
var FieldSet = exports.FieldSet = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var name = _ref.name,
    label = _ref.label,
    helperText = _ref.helperText,
    error = _ref.error,
    required = _ref.required,
    disabled = _ref.disabled,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'column' : _ref$direction,
    className = _ref.className,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("fieldset", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    className: (0, _helpers.cn)(formClasses({
      className: className
    })),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("legend", {
        "aria-disabled": disabled,
        className: (0, _classes.labelClasses)({
          error: Boolean(error),
          disabled: Boolean(disabled),
          className: 'font-semibold'
        }),
        children: [label, required && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          "aria-label": "required",
          className: (0, _classes.requiredClasses)(),
          children: "*"
        })]
      })
    }), helperText && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classes.helperClasses)({
        className: 'mt-2'
      }),
      children: helperText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: controlClasses({
        direction: direction
      }),
      children: _react.Children.map(children, function (child) {
        return /*#__PURE__*/(0, _react.cloneElement)(child, _objectSpread(_objectSpread({
          name: name
        }, required && {
          required: true
        }), disabled && {
          disabled: true
        }));
      })
    }), error && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classes.errorClasses)(),
      children: error
    })]
  }));
});